<template>
  <div>
    <div class="col-sm-6">
      <div class="h-title">{{$t('Security.auth.ne')}}</div>
      <div class="e-input-group m-b-8">
        <ejs-textbox :placeholder="$t('Security.auth.search')" v-model="keyword" :change="search">
          <span class="icon hero-icon hero-icon-search"></span>
        </ejs-textbox>
      </div>
      <div class="tree-box h-security-role-rightTree">
        <tree
          :setting="nodeAuthSetting"
          :nodes="nodeAuthNodes"
          @onCreated="handleNodeAuthCreated"
          @onCheck="checkNodeAuth"/>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="h-title">{{$t('Security.auth.fun')}}</div>
      <div class="tree-box h-security-role-rightTree">
        <tree
          :setting="resourceAuthSetting"
          :nodes="resourceAuthNodes"
          @onCreated="handleResourceAuthCreated"
          @onCheck="checkResourceNode"/>
      </div>
    </div>
  </div>
</template>

<script>
import tree from 'vue-giant-tree'

export default {
  name: 'AddRoleP2',
  components: {
    tree
  },
  data () {
    return {
      roleId: '',
      keyword: '',
      nodeAuthTreeObj: '',
      resourceAuthTreeObj: '',
      nodeAuthNodes: [],
      resourceAuthNodes: [],
      filterNodes: [],
      nodeAuthSetting: {
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parentId',
            rootPId: 0
          }
        },
        check: {
          chkboxType: { 'Y': '', 'N':'' },
          chkStyle: 'checkbox',
          enable: true
        }
      },
      resourceAuthSetting: {
        data: {
          key: {
            name: 'nameStr'
          },
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parentId',
            rootPId: 0
          }
        },
        check: {
          chkboxType: { 'Y': 'ps', 'N':'ps' },
          chkStyle: 'checkbox',
          enable: true
        }
      },
      resourceIdChecked: [],
      nodeIdChecked: []
    }
  },
  methods: {
    handleNodeAuthCreated(ztreeObj) {
      this.nodeAuthTreeObj = ztreeObj
      this.nodeAuthTreeObj.expandAll(true)
      this.setNodeChecked()
    },
    handleResourceAuthCreated(ztreeObj) {
      this.resourceAuthTreeObj = ztreeObj
      this.resourceAuthTreeObj.expandAll(true)
      this.setResourceChecked()
    },
    initTreeData() {
      this.findNodeData()
      this.findAuthData()
    },
    findNodeData() {
      const url = "/lte/ems/auth/getNetAndDev";
      this.axios.get(url).then(response => {
        const result = response.data.resultVal;
        this.filterNodes = result
        this.nodeAuthNodes = result
      });
    },
    findAuthData() {
      const url = "/lte/ems/res/findResource";
      this.axios.get(url, { params: {} }).then(response => {
        const result = response.data;
        this.resourceAuthNodes = result
      })
    },
    checkNodeAuth(event, treeId, treeNode) {
      const subNodes = treeNode.children
      const disabledStatus = treeNode.checked
      let subCheckedNodes = this.nodeAuthTreeObj.getNodesByParam('checked', true, treeNode)
      this.cancelCheckedNodes(subCheckedNodes)
      this.disabledNodeCheck(subNodes, disabledStatus)
      this.setChildProps()
    },
    cancelCheckedNodes(subCheckedNodes) {
      if (!!subCheckedNodes) {
        subCheckedNodes.forEach(node => {
          this.nodeAuthTreeObj.checkNode(node, false, false, false)
        });
      }
    },
    disabledNodeCheck(subNodes, disabledStatus) {
      if (!!subNodes) {
        subNodes.forEach(node => {
          this.nodeAuthTreeObj.setChkDisabled(node, disabledStatus, false, true)
        });
      }
    },
    checkResourceNode(event, treeId, treeNode) {
      const subNodes = treeNode.children
      const checkedStatus = treeNode.checked
      this.checkedSubNode(subNodes, checkedStatus)
      this.setChildProps()
    },
    checkedSubNode(subNodes, checkedStatus) {
      if (!!subNodes) {
        // 子节点勾选
        subNodes.forEach(node => {
          this.resourceAuthTreeObj.checkNode(node, checkedStatus, false, false)
        });
      }
    },
    search() {
      // 前台过滤
      this.keyword = this.keyword.trim()
      if (this.keyword == "") {
        this.nodeAuthNodes = this.filterNodes
      } else{
        const fuzzyResult = this.filterNodes.filter(node => node.name.indexOf(this.keyword)!=-1)
        let filterResult = []
        fuzzyResult.forEach(item => {
          let filterTemp = this.filterParentNode(item)
          filterTemp.forEach(node => {
            if (filterResult.filter(r => r.id == node.id).length == 0){
              filterResult.push(node)
            }
          })
        })
        this.nodeAuthNodes = filterResult
      }
    },
    filterParentNode(item) {
      let nextSubNodes = []
      if (item.parentId != 0) {
        nextSubNodes = this.filterParentNode(this.filterNodes.filter(node => node.id == item.parentId)[0])
      }
      nextSubNodes.push(item)
      return nextSubNodes;
    },
    setNodeChecked() {
      this.nodeIdChecked.forEach(item => {
        let pnode = this.nodeAuthTreeObj.getNodeByParam('id', item.nodeId)
        let subCheckedNodes = this.nodeAuthTreeObj.getNodesByParam('checked', true, pnode)
        this.nodeAuthTreeObj.checkNode(pnode, true, false, false)
        this.cancelCheckedNodes(subCheckedNodes)
        this.disabledNodeCheck(pnode.children, true)
      })
    },
    setResourceChecked() {
      this.resourceIdChecked.forEach(item => {
        let pnode = this.resourceAuthTreeObj.getNodeByParam('id', item)
        this.resourceAuthTreeObj.checkNode(pnode, true, false, false)
      })
    },
    setChildProps() {
      let resourceCheckedNodes = this.resourceAuthTreeObj.getCheckedNodes(true)
      let nodeCheckedNodes = this.nodeAuthTreeObj.getCheckedNodes(true)
      let resourceIds = []
      let nodeIds = []
      resourceCheckedNodes.forEach(node => {
        resourceIds.push(node.id)
      })
      nodeCheckedNodes.forEach(node => {
        nodeIds.push({ 'nodeId': node.id, 'typeCode': node.typeCode })
      })
      this.$emit("childProps", {
        nodeDomain: nodeIds,
        permission: resourceIds
      });
    },
    init(roleParams){
      this.roleId = roleParams.roleId;
      this.resourceIdChecked = roleParams.resourceIdList;
      this.nodeIdChecked = roleParams.nodeIdList;
      this.$emit("childProps", {
        nodeDomain: this.nodeIdChecked,
        permission: this.resourceIdChecked
      });
    }
  }, 
  mounted () {
  }
}
</script>
<style>
.tree-box {
  width: 300px;
  max-height: 450px;
}
</style>

